export interface OrderColumn {
  key: string;
  label: string;
}

// If these get changed make sure to update
// libs/customer-portal/orders/feature-main/src/lib/orders-table/orders-downloader.ts
// and the sorting in
// libs/customer-portal/orders/feature-main/src/lib/orders-table/orders-table.component.ts
export const OrderColumns: OrderColumn[] = [
  { key: 'tripStatus', label: 'Order status' },
  { key: 'tmsOrderId', label: 'Order number' },
  { key: 'bol', label: 'BOL' },
  { key: 'currentArrivalStatus', label: 'Arrival status' },
  { key: 'isAssigned', label: 'Planning status' },
  { key: 'customer', label: 'Customer' },
  { key: 'origin', label: 'Origin' },
  { key: 'originEta', label: 'ETA to origin' },
  { key: 'nextStop', label: 'Next stop' },
  { key: 'nextStopEta', label: 'ETA to next stop' },
  { key: 'destination', label: 'Destination' },
  { key: 'destinationEta', label: 'ETA to destination' },
  { key: 'completedStops', label: 'Completed stops' },
  { key: 'remainingStops', label: 'Stops remaining' },
  { key: 'remainingMilesToNextStop', label: 'Distance to next stop' },
  { key: 'tempRange', label: 'Temp range' },
  { key: 'sensor1', label: 'Sensor 1' },
  { key: 'sensor2', label: 'Sensor 2' },
  { key: 'sensor3', label: 'Sensor 3' },
  { key: 'returnAir1', label: 'Return air 1' },
  { key: 'returnAir2', label: 'Return air 2' },
  { key: 'returnAir3', label: 'Return air 3' },
  { key: 'lastUpdatedDate', label: 'Last temperature update' },
  { key: 'pickupTime', label: 'Scheduled pick-up date/time' },
  { key: 'deliveryTime', label: 'Scheduled delivery date/time' },
  { key: 'tractor', label: 'Tractor' },
  { key: 'trailer', label: 'Trailer' }
];
